module.exports = __webpack_public_path__ + "images/cdae5a7e5f1ec646338d84d45c18779d-playpause.svg";